<template>
  <section id="partners">
    <h1 class="no-pad" v-html="partners.title"></h1>
    <partner :post="subpage" v-for="subpage in subpages" :key="subpage.uid">
    </partner>
  </section>
</template>

<script>
import Partner from '../components/Partner.vue'

export default {
  name: 'partners',
  components: {
    Partner
  },
  computed: {
    partners () {
      return this.$store.getters.getPageByUID('partners')
    },
    subpages () {
      return this.$store.getters.getPagesByType('partner')
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';
</style>
